import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import Pagination from '../../../features/Pagination/Pagination';
import { OptionButton } from '../../../utils/Button';
import { TableSortArrow } from '../../../utils/IconComp';
import InstOption from '../../../utils/InstOption';
import { GetDate } from '../../../utils/Show';
import { mkRelativeUrl } from '../../../utils/URL';
import cn from '../../../utils/cn';

function TableRow({ data, handleCreateSupportTicket }) {
    const navigate = useNavigate();
    const [showMenu, setShowMenu] = useState(false);
    const handleShowMenu = (e, item) => {
        e.stopPropagation();
        setShowMenu(item);
    };
    const limitBy = [
        { key: 'ppu', value: 'Pay Per Use' },
        { key: 'lifetime', value: 'Life Time' },
        { key: 'duration', value: 'Duration' }
    ];

    if (!data?.length) {
        return (
            <tr className="hover:!bg-inherit">
                <td colSpan={9} className="!text-left">
                    No Subscription Found!
                </td>
            </tr>
        );
    }

    return data?.map((item) => (
        <tr
            key={item?.id}
            className={cn(`group`, {
                'placeholder-mode': item?.demo
            })}
        >
            <td>
                <span>{item?.id}</span>
            </td>
            <td onClick={() => navigate(mkRelativeUrl(`/subscriptions/manage/${item?.id}/info`))}>
                <span className="group-hover:text-secondary group-hover:font-medium cursor-pointer hover:underline text-ellipsis block w-full overflow-hidden">
                    {item?.subscriptionName}
                </span>
                <span className="text-secondary text-xs lowercase overflow-hidden text-ellipsis block w-full ">
                    {item?.domain}
                </span>
            </td>
            <td
                // onClick={() => navigate(mkRelativeUrl(``))}
                className="cursor-pointer group-hover:text-secondary hover:underline"
            >
                <Link
                    to={`/agency/${item?.customerInfo?.agencyId || 0}/customers/${item?.customerInfo?.id}/info`}
                    className="group-hover:text-secondary group-hover:font-medium cursor-pointer hover:underline text-ellipsis block w-full overflow-hidden"
                >
                    {item?.customerInfo?.organization || '-----'}
                </Link>
            </td>
            <td>
                <span className="text-ellipsis block w-full overflow-hidden">
                    {item?.customerInfo?.primaryEmail}
                </span>
            </td>
            <td className="">
                <span>
                    {
                        limitBy.find((itemThis) => itemThis.key === item?.limitBy?.toLowerCase())
                            ?.value
                    }
                </span>
            </td>
            <td className="text-center">
                <span>{GetDate(item?.timeFirstInstallation) || 'No Installation Date'}</span>
            </td>
            <td className="text-center">
                <span>{GetDate(item?.timeSubscriptionStart) || 'No Start Date'}</span>
            </td>
            <td
                className={cn('text-center', {
                    '*:!font-medium': item?.expireSoon,
                    '*:text-error': item?.expireDay <= 30,
                    '*:text-yellow-400': item?.expireDay <= 45 && item?.expireDay > 30
                })}
            >
                <span>{GetDate(item.timeSubscriptionEnd) || 'No End Date'}</span>
            </td>
            <td className="text-center capitalize">
                <span className={item?.status === 'active' ? 'text-secondary' : 'text-warning'}>
                    {item?.status}
                </span>
            </td>
            <td>
                <div className="flex flex-row w-full justify-end relative">
                    <span>
                        <OptionButton onClick={(e) => handleShowMenu(e, item)} />
                        <InstOption
                            showMenu={showMenu?.id === item?.id}
                            setShowMenu={setShowMenu}
                            className="w-44"
                        >
                            <button
                                type="button"
                                onClick={(ev) =>
                                    handleCreateSupportTicket(ev, item?.customerInfo?.id, item?.id)
                                }
                            >
                                Create Support Ticket
                            </button>
                            <button
                                type="button"
                                onClick={() =>
                                    navigate(
                                        mkRelativeUrl(`/subscriptions/manage/${item?.id}/info`)
                                    )
                                }
                            >
                                Manage
                            </button>
                        </InstOption>
                    </span>
                </div>
            </td>
        </tr>
    ));
}
function TableHeader({ sortBy, sortedColumn, sortedHandler }) {
    return (
        <thead>
            <tr>
                <th onClick={() => sortedHandler('id')} scope="col">
                    <span className="">ID</span>
                    <TableSortArrow name="id" sortBy={sortBy} sortedColumn={sortedColumn} />
                </th>
                <th onClick={() => sortedHandler('subscription')} scope="col">
                    <span>Subscription</span>
                    <TableSortArrow
                        name="subscription"
                        sortBy={sortBy}
                        sortedColumn={sortedColumn}
                    />
                </th>
                <th onClick={() => sortedHandler('user')} scope="col">
                    <span>Customer Info.</span>
                    <TableSortArrow name="user" sortBy={sortBy} sortedColumn={sortedColumn} />
                </th>
                <th scope="col" className="!cursor-default">
                    <span>Email</span>
                </th>
                <th onClick={() => sortedHandler('limit-by')} scope="col" className="w-32">
                    <span>Limit By</span>
                    <TableSortArrow name="limit-by" sortBy={sortBy} sortedColumn={sortedColumn} />
                </th>
                <th
                    onClick={() => sortedHandler('install-date')}
                    scope="col"
                    className="w-36 text-center"
                >
                    <span data-tooltip-id="tblTooltip" data-tooltip-content="Date of Installation">
                        Inst. Date
                    </span>
                    <TableSortArrow
                        name="install-date"
                        sortBy={sortBy}
                        sortedColumn={sortedColumn}
                    />
                </th>
                <th
                    onClick={() => sortedHandler('subscription-start')}
                    scope="col"
                    className="w-30 text-center"
                >
                    <span
                        data-tooltip-id="tblTooltip"
                        data-tooltip-content="Date of Subscription Start"
                    >
                        Subs. Start
                    </span>
                    <TableSortArrow
                        name="subscription-start"
                        sortBy={sortBy}
                        sortedColumn={sortedColumn}
                    />
                </th>
                <th
                    onClick={() => sortedHandler('subscription-end')}
                    scope="col"
                    className="w-30 text-center"
                >
                    <span
                        data-tooltip-id="tblTooltip"
                        data-tooltip-content="Date of Subscription End"
                    >
                        Subs. End
                    </span>
                    <TableSortArrow
                        name="subscription-end"
                        sortBy={sortBy}
                        sortedColumn={sortedColumn}
                    />
                </th>
                <th
                    onClick={() => sortedHandler('status')}
                    scope="col"
                    className="w-20 text-center"
                >
                    <span>Status</span>
                    <TableSortArrow name="status" sortBy={sortBy} sortedColumn={sortedColumn} />
                </th>
                <th scope="col">#</th>
            </tr>
        </thead>
    );
}

function SubscriptionsPageTable({
    data = {},
    handleCreateSupportTicket,
    onChangePage,
    sortedHandler,
    sortedColumn,
    sortBy
}) {
    return (
        <div className="subscriptions_list_page_table pb-40 overflow-x-auto">
            <table className="bik-table" cellPadding={0} cellSpacing={0}>
                <TableHeader
                    sortedHandler={sortedHandler}
                    sortBy={sortBy}
                    sortedColumn={sortedColumn}
                />
                <tbody>
                    <TableRow
                        data={data?.subscriptions}
                        handleCreateSupportTicket={handleCreateSupportTicket}
                    />
                </tbody>
            </table>
            <Pagination data={data?.pagination || {}} onChangePage={onChangePage} />
        </div>
    );
}

export default SubscriptionsPageTable;
